import ScoreByAnswerToOtherQuestionWidget from './ScoreByAnswerToOtherQuestionWidget';
export default ScoreByAnswerToOtherQuestionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/ScoreByAnswerToOtherQuestionWidget/index.js